import store from "@/store";
const Base64 = require("js-base64").Base64;
export function header(data) {
  let userOrg = data && data ? data : store.getters.userOrg;
  let orgInfo = {};
  if (userOrg) {
    orgInfo = {
      orgUuid: userOrg.orgUuid || "",
      orgCode: userOrg.code || "",
      orgPath: userOrg.path || "",
      orgName: userOrg.orgName || "",
      companyUuid: userOrg.orgParentUuid,
      companyCode: userOrg.orgParentCode,
      companyName: userOrg.orgParentName,
      companyPath: userOrg.orgParentPath,
    };
  }
  return {
    "org-info": userOrg ? Base64.encode(JSON.stringify(orgInfo)) : "",
  };
}
